import * as Sentry from '@sentry/browser'
import {dsn, release} from '/env'

if (dsn)
    Sentry.init({dsn, release})

export default Sentry
